<template>
  <header class="header" ref="header">
  
    <div class="logo">
      <img :src="require('../assets/logo.png')" alt="logo" />
    </div>


    <nav class="nav">
      <el-menu :default-active="active" mode="horizontal" router>
        <el-menu-item index="/">{{ $t('nav.menu[0]') }}</el-menu-item>
        <!-- 使用el-menu-item包装a标签并阻止所有路由行为 -->
        <el-menu-item index="/external-link" @click.stop.prevent>
          <a :href="blockExplorerUrl" target="_blank" @click.stop>{{ $t('nav.menu[1]') }}</a>
        </el-menu-item>
        <el-menu-item index="/ecology">{{ $t('nav.menu[2]') }}</el-menu-item>
        <el-menu-item index="/server">{{ $t('nav.menu[3]') }}</el-menu-item>
        <el-menu-item index="/contribute">{{ $t('nav.menu[4]') }}</el-menu-item>
        
        <el-menu-item index="/develop">{{ $t('nav.menu[5]') }}</el-menu-item>
        
        <el-menu-item index="/news">{{ $t('nav.menu[6]') }}</el-menu-item>
      </el-menu>
    </nav>




    <div class="lang-switch">
      <img :src="require('../assets/header/lang.png')" alt="lang-icon" class="lang-icon" />
      <el-select
        ref="langSelect"
        v-model="langue"
        @change="changeLangue"
        @visible-change="onLangDropdownVisibleChange"
        placeholder="请选择"
        class="lang-dropdown"
        popper-class="lang-select-popper"
        :popper-append-to-body="true"
      >
        <el-option label="中文简体" value="zh"></el-option>
        <el-option label="English" value="en"></el-option>
      </el-select>
    </div>





  </header>
</template>

<script>
export default {
  data() {
    return {
      langue: localStorage.getItem('langue') || 'zh',
      active: '/',
    }
  },
  created() {
    this.active = this.$route.path
  },
  mounted() {
    this.syncHeaderOffset();
    window.addEventListener('scroll', this.syncHeaderOffset);
    window.addEventListener('resize', this.syncHeaderOffset);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.syncHeaderOffset);
    window.removeEventListener('resize', this.syncHeaderOffset);
  },
  methods: {
    changeLangue() {

      localStorage.setItem('langue', this.langue);

      window.location.reload();
    },
    // 下拉显示时，强制用视口坐标定位弹层，避免滚动或 transform 造成偏移
    onLangDropdownVisibleChange(visible) {
      if (!visible) return;
      this.$nextTick(() => {
        const triggerEl = this.$refs.langSelect && this.$refs.langSelect.$el;
        const popperEl = document.querySelector('.el-select-dropdown.lang-select-popper');
        if (!triggerEl || !popperEl) return;

        const rect = triggerEl.getBoundingClientRect();
        const margin = 6; // 等同于 .el-popper[x-placement^=bottom] 的 margin-top，可按需微调
        // 固定定位 + 视口坐标
        popperEl.style.position = 'fixed';
        popperEl.style.transform = 'none'; // 禁用 Popper 的 transform，完全用 top/left 定位
        popperEl.style.top = Math.round(rect.bottom + margin) + 'px';
        popperEl.style.left = Math.round(rect.left) + 'px';
        popperEl.style.minWidth = Math.round(rect.width) + 'px';
        popperEl.style.zIndex = '7000'; // 兜底保障层级
      });
    },
    syncHeaderOffset() {
      const viewportWidth = window.innerWidth;
      const isHighZoom = viewportWidth < 1280;
      const sx = window.scrollX || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
      const header = this.$refs.header;
      if (!header) return;
      if (isHighZoom) {
        const designWidth = 1920;
        const calibration = 0;
        const centerOffset = Math.max(0, Math.round((designWidth - viewportWidth) / 2) + calibration);
        const tx = -sx + centerOffset;
        header.style.transform = `translateX(${tx}px)`;
      } else {
        header.style.transform = '';
      }
    }
  },
  computed: {
    blockExplorerUrl() {
      return process.env.VUE_APP_BLOCK_EXPLORER_URL || 'http://bitscan.bitnetworkbc.com'
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: center;
  /* 让 header 的左右内边距也随宽度缩放，避免固定 20px 导致不随宽度变化 */
  padding: 0 20px;
  box-sizing: border-box;
  height: 60px;
  margin: 0 auto;
  position: fixed;
  top: 0; /* 明确固定在顶部 */
  z-index: 999; /* 抬高头部层级，避免被页面其它层覆盖 */
  left: 0;
  right: 0;
  min-width: 1200px;
 
  width: 100%;
 
  background-image: url('../assets/background/navbackground.png');
  background-repeat: no-repeat;
 
  background-size: 100% 100%  ; /* 强制铺满容器 */
  
  flex-shrink: 0;
  /* 左移 logo：距页面左侧的间距随宽度缩小而缩小 */
  .logo {
    margin-left: -1305px;
    z-index: 999;
    position: absolute;
     /* 右移一大部分，随宽度变化 */
  }

  .logo img {
    height: 40px;
    align-items: center;
    position: absolute;
    left: 60px;
    top:-20px;
  }

  .nav {
    flex: 1;
    display: flex;
    justify-content: center;

    .el-menu {
      background: transparent;
      border-bottom: none;

      .el-menu-item,
      .menu-link {
        line-height: 60px;
        font-weight: normal;
        /* 原来是 padding: 0 20px; 改为响应式内边距 */
        padding: 0 20px;
        font-size: 16px;
        color: #ffffff;
        font-family: '微软雅黑';
        display: inline-block;
        text-decoration: none;
        font-family: '微软雅黑';
        
        &.is-active {
          border-bottom: none !important;
          color: #e13d37 !important;
          background: transparent !important;
        }
        
        /* 外部链接样式，与其他菜单项保持一致 */
        a {
          color: inherit;
          text-decoration: none;
          display: inline-block;
          height: 100%;
          width: 100%;
          transform: translateY(-5px); /* 上移2像素 */
          padding-top: 2px; /* 调整顶部内边距补偿transform */
          
          &:hover {
            color: #e13d37 !important;
          }
        }

      }

      .el-menu-item:hover,
      .menu-link:hover {
        color: #e13d37 !important;
        background: transparent !important;
      }
    }
  }




  /* 右移语言切换：距页面右侧的间距随宽度缩小而缩小 */
  .lang-switch {
    
    
    display: flex;
    align-items: center;
    gap: 6px;
    height: 45px;
    width: 155px;
    padding: 0 12px;
    background-color: #fff;
    border-radius: 20px;
    border: 1px solid #ddd;
    position: absolute;
     z-index: 999;
    margin-left: 1030px;
  }

  .lang-icon {
    width: 20px;
    height: 20px;
   
  }


  .lang-dropdown::v-deep .el-input__wrapper {
    border: none !important;
    box-shadow: none !important;
    background-color: transparent !important;
    padding: 0 !important;
    z-index: 999;
  }

  .lang-dropdown::v-deep .el-input__inner {
    border: none !important;
    box-shadow: none !important;
    background-color: transparent !important;
    font-size: 14px;
    color: #333;
    padding: 0 !important;
    height: 45px !important;
    line-height: 45px !important;
    margin-left: 7px;
  }

  .lang-dropdown::v-deep .el-input__suffix {
    // position: static !important;
    height: auto !important;
    width: auto !important;
    margin-left: 5px;
    margin-top: 2px;
  }

  .lang-dropdown::v-deep .el-input:focus-within .el-input__wrapper {
    box-shadow: none !important;
  }

  .el-select-dropdown {
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border: 1px solid #eee;
    padding: 4px 0;
    z-index: 4000 !important;
  }

  .el-select-dropdown__item {
    font-size: 14px;
    padding: 8px 12px;
    color: #333;
     z-index: 4000 !important;
  }

  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    background-color: #f0f0f0;
    color: #2f70e0;
     z-index: 4000 !important;
  }

  .el-select-dropdown__item.selected {
    font-weight: bold;
    color: #2f70e0;
     z-index: 4000 !important;
  }}
  @media (max-width: 768px) {
    .header .container {
      flex-direction: column;
      height: auto;
      padding: 10px 15px;
  
      .nav {
        justify-content: flex-start;
        margin: 10px 0;
      }
  
      .lang-switch {
        margin-top: 5px;
      }
    }
  }
html, body {
  margin: 0;
  padding: 0;
}
.lang-select-popper {
  z-index: 4000 !important;
}
@media (max-width: 1279px) {
  .header {
    background: none !important;
  }
  .header::before {
    content: '';
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-960px);
    width: 1920px;
    height: 60px;
    background-image: url('../assets/background/navbackground.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    pointer-events: none;
  }
}
</style>

<style lang="scss">
/* 非 scoped 样式，作用于挂到 body 的弹层 */
.lang-select-popper {
  z-index: 7000 !important; /* 保证弹层在最上面 */
}
/* 关键修复：让下拉弹层随视口稳定定位（禁用 Popper 自带 transform） */
.lang-select-popper.el-select-dropdown {
  position: fixed !important;
  transform: none !important;
  will-change: auto;
}
</style>




